'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Category = undefined;

var _Category2 = require('./Category');

var _Category3 = _interopRequireDefault(_Category2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Category = _Category3.default;


//////////////////
// WEBPACK FOOTER
// ./src/containers/Category/index.js
// module id = 1808
// module chunks = 0